import { render, staticRenderFns } from "./IndoorSetting.vue?vue&type=template&id=5304c43c&"
import script from "./IndoorSetting.vue?vue&type=script&lang=js&"
export * from "./IndoorSetting.vue?vue&type=script&lang=js&"
import style0 from "./IndoorSetting.vue?vue&type=style&index=0&id=5304c43c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports